//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import React from 'react';
import styled, { css } from 'styled-components';

import { TOP_NAV_BAR_HEIGHT } from '@legacy-components/nav3/navigation-menus/constants/NavMenuItemConstants';
import { getRgbaForThemeHex } from '@utils/getRgbaForThemeHex';

interface Props {
  isOpen: boolean;
}

export const Scrim = ({ isOpen }: Props) => {
  return <StyledScrim isOpen={isOpen} />;
};

const StyledScrim = styled.div<{ isOpen: boolean }>(
  ({ isOpen, theme }) => css`
    position: absolute;
    width: 100vw;
    height: calc(100vh - ${TOP_NAV_BAR_HEIGHT});
    top: ${TOP_NAV_BAR_HEIGHT};
    right: 0;
    bottom: 0;
    left: 0;
    z-index: ${theme.zindex.popoverBackdrop};
    visibility: ${isOpen ? 'visible' : 'hidden'};
    background-color: ${getRgbaForThemeHex(theme.colors.black, 0.3)};
    opacity: 0;
    opacity: ${isOpen ? '1' : '0'};
    transition:
      opacity 0.25s cubic-bezier(0.455, 0.03, 0.515, 0.955),
      visibility linear 0s 0.25s;
    ${isOpen && `transition-delay: 0s;`};
  `,
);
